import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/account-admin',
    name: 'Account',
    component: () => import('@/views/company/admin/HomeView.vue'),
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: '/account-admin/:name',
    name: 'AccountSettingsMainAdmin',
    component: () => import('@/views/company/accounts/AccountSettingsViewAdmin.vue'),
    meta: { requiresAuth: true, requiresAdmin: true, showAccountHeader: true },
  },
  {
    path: '/account-admin/edit/:name',
    name: 'EditAccountViewAdmin',
    component: () => import('@/views/company/accounts/EditAccountAdmin.vue'),
    meta: { requiresAuth: true, showAccountHeader: true },
  },
  {
    path: '/admin/add-account',
    name: 'AddAccount',
    component: () => import('@/views/company/accounts/AddAccountView.vue'),
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: '/products',
    name: 'Products',
    component: () => import('@/views/company/products/ProductsView.vue'),
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: '/products/add-product-template',
    name: 'CreateProductTemplate',
    component: () => import('@/views/company/products/CreateAccountProductsConfig.vue'),
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: '/products/add/:productConfig',
    name: 'AddProduct',
    component: () => import('@/views/company/products/AddProductView.vue'),
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: '/products/edit/:id',
    name: 'EditDashboard',
    component: () => import('@/views/company/products/EditProductView.vue'),
  },
  {
    path: '/products/view/:id',
    name: 'ViewDashboard',
    component: () => import('@/views/company/products/ViewProductView.vue'),
  },
  {
    path: '/account/:name/:productId',
    name: 'EditAccountProducts',
    component: () => import('@/views/company/products/EditAccountProducts.vue'),
    meta: { requiresAuth: true, requiresAdmin: true, showAccountHeader: true },
  },
  {
    path: '/account/edit/:name/:productId',
    name: 'ViewAccountProduct',
    component: () => import('@/views/company/products/ViewAccountProduct.vue'),
    meta: { requiresAuth: true, requiresAdmin: true, showAccountHeader: true },
  },
  {
    path: '/account/view-product-account/:name/:productId',
    name: 'ViewAccountProductsJust',
    component: () => import('@/views/company/products/ViewAccountProductsJust.vue'),
    meta: { requiresAuth: true, requiresAdmin: true, showAccountHeader: true },
  },
  {
    path: '/account/products/:account',
    name: 'AllProductsAccounts',
    component: () => import('@/components/AllProductsAccounts.vue'),
    meta: { requiresAuth: true, requiresAdmin: true, showAccountHeader: true },
  },
  {
    path: '/company-accounts',
    name: 'CompanyUsers',
    component: () => import('@/views/company/users/CompanyUsersView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/client-accounts',
    name: 'ClientUsers',
    component: () => import('@/views/company/users/ClientUsersView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/users/create-user-admin',
    name: 'CreateUserContainer',
    component: () => import('@/views/company/users/CreateUserContainer.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/users/create-company-user',
    name: 'CreateCompanyUser',
    component: () => import('@/views/company/users/CreateCompanyUser.vue'),
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: '/users/create-client-user-simple',
    name: 'CreateClientUserSimple',
    component: () => import('@/views/company/users/CreateClientUserSimple.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/admin',
    name: 'Admin',
    component: () => import('@/views/company/admin/AdminView.vue'),
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: '/activity-logs',
    name: 'ActivityLogs',
    component: () => import('@/views/company/admin/ActivityLogs.vue'),
    meta: { requiresAuth: true, requiresSuperAdmin: true },
  },
  {
    path: '/sso/wordpress',
    name: 'WordPressSSO',
    component: () => import('@/views/company/admin/WordPressSSO.vue'),
    meta: { requiresAuth: true }, // Allow both company and client users
  },
  {
    path: '/sso/wp/callback',
    name: 'WordPressSSOCallback',
    component: () => import('@/views/company/admin/WordPressSSO.vue'),
    meta: { requiresAuth: true }, // Allow both company and client users
  },
]

export default routes
